import { createApp } from 'vue'

import App from './App.vue'

// CSS

import '@/assets/css/bootstrap.min.css'
import '@/assets/css/fontawesome.min.css'
import '@/assets/css/animate.css'
import '@/assets/css/odometer.css'
import '@/assets/css/slick.min.css'
import '@/assets/css/style.css'

// Router
import router from './router'

// i18n
import i18n from './i18n'

// Swiper
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/navigation'

// Toast
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// SEO
import { createHead } from '@unhead/vue'

// Pinia
import { createPinia } from 'pinia'

const head = createHead()
const pinia = createPinia()

// Arabic only
document.documentElement.lang = 'ar'
document.documentElement.dir = 'rtl'

const app = createApp(App)

app
  .use(router)
  .use(i18n)
  .use(Toast)
  .use(head)
  .use(pinia)
  .mount('#app')
